<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="row">
      <div class="col-12">
        <h1 class="title-default">Etapas do kanban de vendas</h1>
        <p class="welcome-message">
          <button mat-icon-button type="button" (click)="voltar()"><mat-icon>arrow_back</mat-icon></button>
          Configure as etapas, o fluxo de movimentação e as permissões por perfil de cada processo.
        </p>
      </div>
    </div>

    @if (isLoading) {
    <div class="row g-4 board-skeleton">
      @for (col of skeletonCols; track $index) {
      <div class="col-12 col-lg-6">
        <div class="sk-coluna">
          <div class="sk-header">
            <div class="sk-box sk-icone"></div>
            <div class="sk-lines">
              <div class="sk-box sk-line sk-line-lg"></div>
              <div class="sk-box sk-line sk-line-sm"></div>
            </div>
            <div class="sk-box sk-toggle"></div>
          </div>
          <div class="sk-divider"></div>
          <div class="sk-cards">
            @for (card of col; track card) {
            <div class="sk-card">
              <div class="sk-box sk-drag"></div>
              <div class="sk-box sk-card-icone"></div>
              <div class="sk-lines">
                <div class="sk-box sk-line sk-line-md"></div>
                <div class="sk-box sk-line sk-line-xs"></div>
              </div>
            </div>
            }
          </div>
        </div>
      </div>
      }
    </div>
    } @else {

    <!-- Como esta tela funciona -->
    <div class="painel ajuda">
      <button type="button" class="painel-head" (click)="mostrarAjuda = !mostrarAjuda">
        <span class="painel-titulo"><mat-icon class="material-symbols-outlined ic-help">help</mat-icon> Como esta tela
          funciona</span>
        <span class="painel-acao">{{ mostrarAjuda ? 'Ocultar ajuda' : 'Mostrar ajuda' }}
          <mat-icon>{{ mostrarAjuda ? 'expand_less' : 'expand_more' }}</mat-icon>
        </span>
      </button>
      @if (mostrarAjuda) {
      <div class="painel-body">
        <p>O quadro de vendas é organizado em processos fixos. Em cada um você cria suas etapas, define para
          quais outras etapas o card pode avançar e quem pode executar cada movimentação.</p>
        <div class="legenda">
          <span><mat-icon class="material-symbols-outlined">play_circle</mat-icon> Inicial — onde o card nasce</span>
          <span class="vermelho"><mat-icon class="material-symbols-outlined">flag</mat-icon> Final — encerra o
            card</span>
          <span class="vermelho"><mat-icon class="material-symbols-outlined">alt_route</mat-icon> Outro processo —
            movimentação entre tipos</span>
          <span class="amarelo"><mat-icon class="material-symbols-outlined">warning</mat-icon> Validação — etapa
            inalcançável, sem saída ou sem perfil</span>
        </div>
      </div>
      }
    </div>

    <!-- Validação -->
    @if (temAvisos) {
    <div class="painel validacao warning">
      <button type="button" class="painel-head" (click)="avisosMinimizados = !avisosMinimizados">
        <span class="painel-titulo"><mat-icon class="material-symbols-outlined ic-warn">warning</mat-icon>
          {{ avisos.length }} aviso(s) de fluxo</span>
        <span class="painel-acao">{{ avisosMinimizados ? 'exibir' : 'minimizar' }}
          <mat-icon>{{ avisosMinimizados ? 'expand_more' : 'expand_less' }}</mat-icon>
        </span>
      </button>
      @if (!avisosMinimizados) {
      <div class="painel-body">
        @for (a of avisos; track $index) {
        <button type="button" class="aviso-item" [class.clicavel]="a.idEtapaKanban" (click)="focarAviso(a)">
          <mat-icon class="material-symbols-outlined" [class.ic-warn]="a.tipo === 'warning'"
            [class.ic-info]="a.tipo === 'info'">
            {{ a.tipo === 'warning' ? 'error' : 'info' }}
          </mat-icon>
          <span class="aviso-msg">{{ a.mensagem }}</span>
          @if (a.idEtapaKanban) { <mat-icon class="material-symbols-outlined chev">chevron_right</mat-icon> }
        </button>
        }
      </div>
      }
    </div>
    } @else {
    <div class="painel validacao ok">
      <span class="painel-titulo"><mat-icon class="material-symbols-outlined ic-ok">verified</mat-icon>
        Fluxo consistente — todas as etapas têm entrada, saída e perfis definidos.</span>
    </div>
    }

    <!-- Aparência do board -->
    <div class="painel aparencia">
      <span class="painel-titulo"><mat-icon class="material-symbols-outlined ic-help">visibility</mat-icon>
        Aparência do board</span>
      <!-- Padrão do design system (ver Devoluções de Vendas): switch à esquerda do rótulo,
           dentro do próprio mat-slide-toggle; texto de apoio abaixo, indentado sob o rótulo. -->
      <div class="toggle-content">
        <mat-slide-toggle class="app-toggle-compact" [checked]="isMostrarSomaColuna"
          [disabled]="isSalvandoSomaColuna" (change)="toggleSomaColuna($event.checked)">
          Mostrar soma por coluna
        </mat-slide-toggle>
        <span class="info-text">
          Exibe, no cabeçalho de cada coluna do board, a soma dos valores dos cards daquela coluna
          (quando o processo tiver campo de valor). Vale para os dois processos.
        </span>
      </div>
    </div>

    <!-- Board: exatamente 2 processos, em colunas de largura igual -->
    <div class="row g-4 board">
      @for (processo of processos; track processo.idConfigKanbanProcesso; let last = $last) {
      <div class="col-12 col-lg-6 proc-col" [class.last]="last">
        <app-kanban-processo-coluna [processo]="processo" [iconesById]="iconesById" [coresById]="coresById"
          [tiposEtapaKanban]="tiposEtapaKanban" [tipoIcone]="tipoIcone(processo.idTipoProcessoKanban)"
          [subtitulo]="tipoSubtitulo(processo.idTipoProcessoKanban)"
          [isObrigatorio]="isProcessoObrigatorio(processo.idTipoProcessoKanban)"
          (adicionar)="adicionar(processo)" (editar)="editar(processo, $event)" (excluir)="excluir($event)"
          (reordenar)="reordenar($event)" (toggleAtivo)="toggleProcesso(processo, $event)">
        </app-kanban-processo-coluna>
      </div>
      }
    </div>
    }
  </div>
</div>